import { Link, List, ListItem, Typography } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const MountainWestConferenceLink = () => (
  <Link
    target="_blank"
    href="http://am.ticketmaster.com/mountainwest/"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
  >
    Account Manager
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Click Continue and connect to your Mountain West Conference account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for the games.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your Mountain West Conference{" "}
        <MountainWestConferenceLink /> within 24 hours of redemption. Reach out
        to Live Fan Support for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Mountain West Conference work?",
    description:
      "The Mountain West Conference lets you fully customize your experience. Choose from the available home games that best fit your schedule and select any available seats for each game—giving you the flexibility to make this season uniquely yours.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all currently available inventory.",
  },
  {
    title: "Where are my tickets delivered?",
    description: (
      <>
        Event tickets are delivered directly within your Mountain West
        Conference <MountainWestConferenceLink />.
      </>
    ),
  },
  {
    title: "Where can I find the tournament brackets?",
    description: (
      <>
        Please use the below links to find the tournament brackets.
        <List sx={{ py: 0 }}>
          <ListItem>
            <Typography variant="body2">
              <Link
                target="_blank"
                href="https://storage.googleapis.com/themw-com/2025/09/7717cdba-2026-mbb-bracket.pdf"
                sx={{
                  fontWeight: 500,
                  color: "primary.main",
                  textDecoration: "none",
                }}
              >
                • Men's Basketball
              </Link>
              <br />
              <Link
                target="_blank"
                href="https://storage.googleapis.com/themw-com/2025/09/347c0d7a-2026-cu1-mw-wbb-championship-bracket.pdf"
                sx={{
                  fontWeight: 500,
                  color: "primary.main",
                  textDecoration: "none",
                }}
              >
                • Women's Basketball
              </Link>
            </Typography>
          </ListItem>
        </List>
      </>
    ),
  },
];

export const RegistrationTerms = () => (
  <>
    By checking this box you agree to receive notifications and offers from the
    Mountain West Conference and to the{" "}
    <Link
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      target={"_blank"}
      href="https://www.attend.tech/terms-of-use"
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/privacy-policy"
    >
      Privacy Policy
    </Link>
    .
  </>
);

export const CheckoutTerms = () => (
  <>
    By purchasing you agree to receive SMS alerts regarding ticket delivery and
    agree to the{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/terms-of-use"
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/privacy-policy"
    >
      Privacy Policy
    </Link>
    .
  </>
);
